import dayjs from "dayjs";
import { DocType } from "../types/types";

export const shortenLargeTexts = (text: string, limitIndex: number): string => {
  let shortVersion = text;

  if (text.length > limitIndex)
    shortVersion = text.substring(0, limitIndex) + "...";

  return shortVersion;
};

export const isCPFValid = (docNumber: string) =>
  docNumber.replace(/[._-]/g, "").length === 11;

export const checkDocNumberValidity = (docNumber: string, docType: DocType) =>
  docType === DocType.CPF && isCPFValid(docNumber);

export const formatDateString = (date: string) =>
  dayjs(date).format("DD/MM/YYYY");

export const getUserFirebasePath = (userName: string, userId: string) =>
  `peregrin/users/${userName}_${userId}`;

export const getStoreImagesFirebasePath = (
  storeName: string,
  storeId: string
) => `peregrin/stores/${storeName}_${storeId}/store-images`;

export const getExcursionsFirebasePath = (
  storeName: string,
  storeId: string,
  excursionTitle: string,
  excursionId: string
) =>
  `peregrin/stores/${storeName}_${storeId}/excursions/${excursionTitle}_${excursionId}`;

export const CNPJ_MASK = "99.999.999/9999-99";
export const PHONE_MASK = "(99) 9.9999-9999";
export const CEP_MASK = "99999-999";
